import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Charge, FormCheckbox, FormSelect } from '.';
import validate from '../helpers/emitChargesInformationValidate';
import focusInputOnError from '../helpers/focusInputOnError';
import { chargesToArray } from '../helpers/utils';
import { useDesktop } from '../hooks';

const chargesOptions = [
  { name: '1 Beneficiario', value: 1 },
  { name: '2 Beneficiarios', value: 2 },
  { name: '3 Beneficiarios', value: 3 },
];

interface IEmitChargesInformationFormProps {
  documentId: string;
  charges: string;
  handleSubmit: () => void;
  previousPage: () => void;
  resetChargePercetage: () => void;
}

export function EmitChargesInformationForm(props: any) {
  const {
    previousPage,
    handleSubmit,
    documentId,
    resetChargePercetage,
    history: { push },
  } = props;
  const [chargesCount, setChargesCount] = useState(chargesToArray('1'));
  const changeChargesCount = ({ target: { value } }: any) => {
    if (value === '1') {
      resetChargePercetage();
    }

    setChargesCount(chargesToArray(value));
  };

  if (!documentId) {
    push('/');
  }

  const [checked, setChecked] = useState(false);
  const legalHeirsCheck = () => setChecked(!checked);
  const desktop = useDesktop();

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT === 'production') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvCargas',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);
    }
  }, []);

  return (
    <div className="col-12 col-md-10 wizard-card">
      <form onSubmit={handleSubmit} noValidate={true}>
        <div className={`row${desktop ? '' : ' ml0 mr0'}`}>
          <div className="col-12">
            <h2 className="wizard-card--title">
              Beneficiarios
              <div className="progress-step">
                <div className="done" />
                <div className="current" />
              </div>
            </h2>
            <p className="mb30">
              Completa la información de tus beneficiarios.
            </p>
          </div>
          <div className="col-12 col-sm-5 col-md-6 col-lg-4 form-group">
            <label htmlFor="charges">Cantidad de beneficiarios</label>
            <Field
              name="charges"
              component={FormSelect}
              options={chargesOptions}
              onChange={changeChargesCount}
              showDefault={false}
              isDisabled={checked}
            />
          </div>
          <div className="col-12 col-sm-5 col-md-6 col-lg-8 form-group pt45">
            <Field
              name="legalHeirs"
              component={FormCheckbox}
              text="Deseo como benefiarios a mis herederos legales"
              onChange={legalHeirsCheck}
            />
          </div>
          <div className="col-12" />
          <div
            className={`col-12 relative${
              checked ? ' disabled-section d-none' : ''
            }`}
          >
            {chargesCount.map(index => (
              <Charge key={index} index={index} chargesCount={chargesCount} />
            ))}
          </div>
        </div>
        <div className="row justify-content-center mt30 buttons-container">
          <div className="col-12 col-sm-5 col-md-4">
            <button
              className="btn white back-to-client-info"
              type="button"
              onClick={previousPage}
            >
              Volver
            </button>
          </div>
          <div className="col-12 col-sm-5 col-md-4">
            <button className="btn primary" type="submit">
              Continuar
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default withRouter(
  reduxForm<any, any>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'proposal',
    initialValues: {
      'charge-percentage-0': '100',
    },
    onSubmitFail: focusInputOnError,
    validate,
  })(EmitChargesInformationForm),
);
